import * as React from "react";
import {
  Column,
  Columns,
  Divider,
  Heading,
  Stack,
  Text,
} from "@origin-digital/ods-core";
import { useFormikContext } from "formik";
import { AccountPayer, FormValues } from "./types";
import ReadOnlyFieldWrapper from "./ReadOnlyFieldWrapper";

const ReadOnlyElecSectionInPremise = ({ homeUser }: { homeUser: boolean }) => {
  const { values } = useFormikContext<FormValues>();
  return (
    <Stack
      space={{
        xs: "large",
        md: "xlarge",
      }}
    >
      <Heading variant="h4">Electricity</Heading>

      <Stack
        space={{
          xs: "xlarge",
          md: "xlarge",
        }}
      >
        {/* Responsibility for account */}
        <ReadOnlyFieldWrapper
          value={values.requestingCompany?.name || homeUser}
        >
          <Columns
            collapseBelow="md"
            space={{
              xs: "none",
              md: "xlarge",
            }}
            alignY="stretch"
          >
            {/* Fields */}
            <Column width="2/3">
              <Stack space="xsmall">
                <Stack space="xxsmall">
                  <Text variant="body-small" tone="neutralLight">
                    Who’s responsible for the electricity account?
                  </Text>
                  <Text>
                    {values.electricityAccountPayer ===
                    AccountPayer.SOMEONE_ELSE
                      ? "Customer"
                      : values.requestingCompany?.name || "Me/My Company"}
                  </Text>
                </Stack>
                <Divider />
              </Stack>
            </Column>
            {/* Fields */}
            {/* HelperText */}
            <Column width="1/3" />
            {/* End HelperText */}
          </Columns>
        </ReadOnlyFieldWrapper>
        {/* End Responsibility for account */}

        {/* Assign to */}
        <ReadOnlyFieldWrapper value={values.serviceAssignee}>
          <Columns
            collapseBelow="md"
            space={{
              xs: "none",
              md: "xlarge",
            }}
            alignY="stretch"
          >
            {/* Fields */}
            <Column width="2/3">
              <Stack space="xsmall">
                <Stack space="xxsmall">
                  <Text variant="body-small" tone="neutralLight">
                    Assigned to
                  </Text>
                  <Text>{values.serviceAssignee}</Text>
                </Stack>
                <Divider />
              </Stack>
            </Column>
            {/* Fields */}
            {/* HelperText */}
            <Column width="1/3" />
            {/* End HelperText */}
          </Columns>
        </ReadOnlyFieldWrapper>
        {/* End Assign to */}
      </Stack>
    </Stack>
  );
};

export default ReadOnlyElecSectionInPremise;
